import styled from 'styled-components';

import ParadexLogoText from '#/assets/ParadexLogoText';
import ParadexLogoIcon from '#/assets/ParadexLogoIcon';
import BetaIcon from '#/assets/BetaIcon';

import { c07071D, mainGridGapColor } from '#/colors';

import Wallet from '#/components/common/wallet/Wallet';
import { MEDIA, mdVisible, smVisible } from '#/features/layout/media-queries';
import NotificationsButton from '#/components/common/notifications/NotificationsButton';

import { useAccountView } from '#/features/account/account-context';
import { ChainEnvsProvider } from '#/features/chain-envs/chain-envs-context';

import { APP_BAR_HEIGHT } from './styles';
import Nav from './Nav';
import BurgerMenuNav from './BurgerMenuNav';
import JoinWaitlist from './JoinWaitlist';
import AccountStatusBadge from './AccountStatusBadge';

export default function AppBar() {
  return (
    <Container>
      <Logo />
      <Navigation />
      <Actions />
    </Container>
  );
}

function Logo() {
  return (
    <LogoContainer css="grid-area: logo;">
      <ParadexLogoIcon css={smVisible} />
      <ParadexLogoText css={mdVisible} />
      <BetaIcon />
    </LogoContainer>
  );
}

function Navigation() {
  const accountView = useAccountView();
  return (
    <div css="grid-area: nav">
      <ChainEnvsProvider>
        <BurgerMenuNav css={smVisible} />
        <Nav css={mdVisible}>
          {accountView.status.value !== 'ACTIVE' && (
            <li>
              <AccountStatusBadge />
            </li>
          )}
        </Nav>
      </ChainEnvsProvider>
    </div>
  );
}

function Actions() {
  return (
    <ContainerActions css="grid-area: actions">
      <AccountStatusBadge css={smVisible} />
      <JoinWaitlist css={mdVisible} />
      <NotificationsButton css={smVisible} />
      <Wallet />
    </ContainerActions>
  );
}

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-right: 24px;

  &:first-child {
    margin-left: -8px;
  }

  @media ${MEDIA.md} {
    &:first-child {
      margin-left: 0px;
    }
  }
`;

const Container = styled.header`
  height: ${APP_BAR_HEIGHT};
  min-height: ${APP_BAR_HEIGHT};
  display: grid;
  align-items: center;
  padding: 0 16px;
  background-color: ${c07071D};
  border-bottom: 1px solid ${mainGridGapColor};
  overflow: auto;

  /* 0px – md */
  grid-template-columns: 1fr auto auto;
  grid-template-areas: 'logo actions nav';
  gap: 8px;

  @media ${MEDIA.md} {
    grid-template-columns: auto 1fr auto;
    grid-template-areas: 'logo nav actions';
    gap: 16px;
  }
`;

const ContainerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
